import { FeatureFlags } from '../../../api/features.service';

class SavingsPuckDetailsCtrl {
  static bindings = {
    account: '<',
    rfp: '<',
    puck: '<',
    offerId: '<',
    onCloseDetails: '&',
    featureList: '<',
    // seller side only
    tierId: '<',
    usePrimaryEquivalentCrosses: '<',

    // buyer side only
    masterPlanId: '<'
  };

  account;
  rfp;
  puck;
  offerId;
  onCloseDetails;
  tierId;
  usePrimaryEquivalentCrosses;
  masterPlanId;
  offerImpacts;
  microChartSize;
  benchmarksGraph;
  featureList: FeatureFlags;

  constructor(private api, private BuyerOfferImpact) {
    'ngInject';
  }

  $onInit() {
    if (this.account.isSeller) {
      this.microChartSize = 'large';
    }

    if (this.account.isBuyer && this.puck.activeSellerImpact) {
      let spendBenchmark = this.puck.activeSellerImpact.spendBenchmark;

      this.benchmarksGraph = {
        data: {
          benchmarks: {
            all: {
              currentRanking: spendBenchmark.continuedAllBuyersBenchmark,
              plannedRanking: spendBenchmark.plannedAllBuyersBenchmark,
              range: 'loading' // loading, loaded, unavailable
            },
            similar: {
              currentRanking: spendBenchmark.continuedSimilarBuyersBenchmark,
              plannedRanking: spendBenchmark.plannedSimilarBuyersBenchmark,
              range: 'loading' // loading, loaded, unavailable
            }
          },
          savingsAmount:
            this.puck.continuedSpend +
            this.puck.activeSellerImpact.additionalValue -
            this.puck.plannedSpend
        },
        config: {
          benchmarkType: 'similar',
          templateName: 'group-impact-details'
        }
      };

      this.loadBenchmarks();
    }
  }

  $onChanges(changes) {
    if (changes.rfpId || changes.puck || changes.offerId || changes.tierId) {
      this.loadDetails();
    }

    // QA-1889 - I've removed this because it causes errors due to the activeSellerImpact not being
    // available on the puck data and I can see nothing that suggests that we have a modal macro-chart
    // anymore.

    // if (changes.puck && !changes.puck.isFirstChange()) {
    //   this.loadBenchmarks();
    // }
  }

  loadBenchmarks() {
    // Kick off yet another call to get the benchmark ranges we need for the modal macro-chart.
    // priceType, duration, marketShare
    this.api.rfps.sellers
      .getPricingBenchmarksWithOfferId(
        this.rfp.id,
        this.puck.activeSellerImpact.sellerId,
        this.puck.id,
        this.offerId,
        this.puck.activeSellerImpact.targetMarketShare
      )
      .then((results) => {
        // Set the range indicators to let external code know whether we were able to get benchmark numbers or not
        // for each type of range.
        this.updateBenchmarksGraphWithBenchmarkRanges(this, results);
      });
  }

  // This gets called when the puck gets clicked
  // TODO: Make sure this only loads once unless things have changed
  loadDetails() {
    if (this.rfp.id && this.puck && this.offerId) {
      if (this.account.isSeller && this.tierId) {
        // Clear this out till the new data loads
        this.offerImpacts = null;

        // TODO: Move this inside condition below?
        // offerImpacts appears to be used only to display the facilities -- why not just make a facilities call
        this.api.rfps
          .getOfferImpactsForSeller(
            this.rfp.id,
            this.puck.id,
            this.offerId,
            this.tierId,
            this.usePrimaryEquivalentCrosses
          )
          .then((offerImpacts) => {
            this.offerImpacts = offerImpacts;
          });

        // If this is a "Spend Not Included" puck then we don't need to go get details
        // To do so is to invite errors which then display to the end user
        if (
          this.account.isSeller &&
          !this.BuyerOfferImpact.noSpend(this.puck)
        ) {
          //
        }
      } else if (this.account.isBuyer && this.masterPlanId) {
        // Clear this out till the new data loads
        this.offerImpacts = null;

        // TODO: Move this inside condition below?
        // offerImpacts appears to be used only to display the facilities -- why not just make a facilities call
        this.api.rfps
          .getOfferImpactsForBuyer(
            this.rfp.id,
            this.puck.id,
            this.offerId,
            this.masterPlanId
          )
          .then((offerImpacts) => {
            this.offerImpacts = offerImpacts;
          });
      }
    }
  }

  updateBenchmarksGraphWithBenchmarkRanges(target, results) {
    target.benchmarksGraph.data.benchmarks.all.range = 'unavailable';
    target.benchmarksGraph.data.benchmarks.similar.range = 'unavailable';
  }

  nameLink(puck) {
    if (this.account.isBuyer) {
      return '../buyer/viewBuyerProfile?orgId=' + puck.id;
    } else {
      return '../seller/SellerViewBuyerProfile?orgId=' + puck.id;
    }
  }

  // FIXME: These values may not be the same as with flag off
  // QA is verifying whether this is a bug
  getSavingsPercentage() {
    // For SIO, we need to show N/A for continuedSpend, so we need to show N/A here too
    // We also can't divide by 0, so I guess we'll show N/A for that too
    if (this.puck.continuedSpend == null || this.puck.continuedSpend == 0) {
      return null;
    }

    return this.puck.plannedSpend
      ? Math.round((this.puck.savings / this.puck.continuedSpend) * 100.0)
      : 0;

    // What is potentialMarketSharePercentage? Where is it used? Is it still needed?
    // targetPuck.potentialMarketSharePercentage =
    //     puckDetails.potentialSpend ? Math.round((puckDetails.plannedSpend / puckDetails.potentialSpend) * 100.0) : 0;
  }

  closeDetails() {
    this.onCloseDetails();
  }

  // These get used within the pucks to set the initial status of the radio buttons (with an override for the seller
  // inclusion status).
  inStatus(puck) {
    if (
      puck &&
      puck.activeSellerImpact &&
      puck.activeSellerImpact.inclusionStatus === 'In'
    ) {
      return true;
    }
  }

  outStatus(puck) {
    if (
      puck &&
      puck.activeSellerImpact &&
      puck.activeSellerImpact.inclusionStatus === 'Out'
    ) {
      return true;
    }
  }

  // Opt In / Out
  updateStatus(puck, dataSet, included) {
    // Update the system status to reflect the change.
    this.BuyerOfferImpact.setSystemStatus(
      this.masterPlanId,
      puck.id,
      dataSet.id,
      included
    );

    // Update our local cached copy to reflect the updated status
    // FIXME: We should do this in a .then callback to make sure the update actually worked
    puck.activeSellerImpact.inclusionStatus = included ? 'In' : 'Out';

    // Close the puck before the re-sort happens
    this.closeDetails();

    // TODO: notify parent to recalculate

    // $scope.recalculateNumbersForBuyer(dataSet);
    // $scope.updateGraphsForBuyer(dataSet.overview);
  }

  canInOut() {
    if (!this.puck.activeSeller || !this.puck.activeSeller.permissions) {
      return false;
    }

    let permissions = this.puck.activeSeller.permissions;
    let orgId = this.puck.orgId || this.puck.id;

    return this.BuyerOfferImpact.canInOut(this.account, permissions, orgId);
  }

  getPurchasePlanUrl() {
    //This component can be used
    var prefix = window.location.pathname;
    var suffix = `/ppDetails/${this.rfp.id}/member/${this.puck.id}`;
    return prefix + '#' + suffix;
  }

  // hideDetails () {
  //   delete $scope.activePuck;
  //   delete $scope.activePuckRowNumber;

  //   // Dump any cached data for the pucks by row. Resorting is only allowed when the details are hidden.
  //   if ($scope.activeDataSet) {
  //     delete $scope.activeDataSet.pucksByRow;
  //   }
  // }
}

export const SavingsPuckDetailsComponent = {
  template: require('./savingsPuckDetails.component.html'),
  controller: SavingsPuckDetailsCtrl,
  bindings: SavingsPuckDetailsCtrl.bindings
};
